import React from "react";

function ProductAndDescription({ activeButtonText, descriptionText, price }) {
  return (
    <div className="text-center pt-2 pb-6 -mt-1">   {/* ← ESTO es lo único que cambia */}
      {/* TÍTULO ÉPICO – bien arriba */}
      <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-3 tracking-tight drop-shadow-2xl">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-amber-400 to-yellow-500">
          {activeButtonText}
        </span>
      </h2>

      {/* Todo lo demás 100 % igual que antes */}
      <p 
        className="text-base mb-4 text-white"
        dangerouslySetInnerHTML={{ __html: descriptionText }}
      />

      {price && (
        <p className="text-xl font-semibold text-yellow-400 mt-2 tracking-wide">
          {price}
        </p>
      )}
    </div>
  );
}

export default ProductAndDescription;